const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/generalUtils.ts';
import { DateTime } from 'luxon';
import { getMainConfig, GlobalCommonAppSettings } from '@cistec/common_web/services/mainConfig';

/**
 * Types for the app settings of patdash
 */
export interface GlobalPatAppSettings extends GlobalCommonAppSettings {
    hospitalLongName: string;
    iamUrl: string;
}

export function getPatAppSettings(): GlobalPatAppSettings {
    return getMainConfig().settings as GlobalPatAppSettings;
}

export const isApple = ['apple computer'].reduce(
    (prev, current) => prev || navigator.vendor.toLowerCase().indexOf(current) !== -1,
    false
);

export const appAuthTimeDiffCalcWithThreshold = (expiractionDatetime: string): number => {
    const timestampZ = new Date(expiractionDatetime).getTime();
    const now = new Date().getTime();
    // 2000ms is threshold
    return timestampZ - now - 2000;
};

export const appAuthTimeDiffError = (expirationDatetime: string): boolean => {
    // add again 2000ms of threshold
    return appAuthTimeDiffCalcWithThreshold(expirationDatetime) < 2000;
};

export const hasNativeWrapper = typeof (window as any).ReactNativeWebView !== 'undefined';

/**
 * KISIM uses this format for all values that come directly from SQL.
 * It's also the standard format used by most KISAPI calls.
 */
export const STD_REVERSE_DATE_TIME = 'yyyy-LL-dd HH:mm:ss';

export function luxonToStdReverse(dt: DateTime): string {
    return dt.toFormat(STD_REVERSE_DATE_TIME);
}
